<!-- if session did not expired show full menu -->
<div class="btn-group" *ngIf="!isSessionExpired">
    <button class="btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" (click)="showOrgInfo();">
        {{ userlabel }}
    </button>
    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
        <li>
            <a class="dropdown-item">{{ userid }}</a>
        </li>
        <li *ngIf="organisationid">
            <a class="dropdown-item">{{ organisationid }} {{ org_type }} {{ org_name }}</a>
        </li>
        <div *ngIf="organisationid" class="dropdown-divider"></div>
        <li *ngIf="organisationid">
            <a class="dropdown-item clickable-link" (click)="switchOrganisationConfirm();" title="Log in with another organisation for which you are registered as a users">Log in with another organisation</a>
        </li>
        <div class="dropdown-divider"></div>
        <li>
            <a class="dropdown-item clickable-link" title="Log out"  (click)="logoutConfirm();">Log out</a>
        </li>   
    </ul>
</div>

<!-- if session expired show just the userid -->
<div *ngIf="isSessionExpired" class="me-2">
    {{ userid }}
</div>
